var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.paramsWithQty),function(param,paramKey){return _c('ProductParamItem',{key:paramKey,attrs:{"data":param,"select-qty":param.selectQty,"max-qty":_vm.handleParamMaxQty(param.size)},on:{"change":function (selectQty) {
      _vm.updateSelectedValue(selectQty, param)
    }}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }